import React, { lazy, Suspense } from 'react';
import { LazyMotion, domAnimation } from 'framer-motion';
import { TopBar } from './components/sections/TopBar';
import { Hero } from './components/sections/Hero';
import { ProblemAgitation } from './components/sections/ProblemAgitation';
import { StickyCTA } from './components/ui/StickyCTA';

// Everything below the hero is code-split into its own chunk and loaded right
// after the initial paint — none of it is needed to render the first screen,
// so it shouldn't compete with the hero/LCP for the browser's main thread.
const TrustStats = lazy(() => import('./components/sections/TrustStats').then(mod => ({
  default: mod.TrustStats
})));
const Transformation = lazy(() => import('./components/sections/Transformation').then(mod => ({
  default: mod.Transformation
})));
const Method = lazy(() => import('./components/sections/Method').then(mod => ({
  default: mod.Method
})));
const ForYou = lazy(() => import('./components/sections/ForYou').then(mod => ({
  default: mod.ForYou
})));
const WhatYouGet = lazy(() => import('./components/sections/WhatYouGet').then(mod => ({
  default: mod.WhatYouGet
})));
const BonusesDetail = lazy(() => import('./components/sections/BonusesDetail').then(mod => ({
  default: mod.BonusesDetail
})));
const InstantAccess = lazy(() => import('./components/sections/InstantAccess').then(mod => ({
  default: mod.InstantAccess
})));
const Testimonials = lazy(() => import('./components/sections/Testimonials').then(mod => ({
  default: mod.Testimonials
})));
const FAQ = lazy(() => import('./components/sections/FAQ').then(mod => ({
  default: mod.FAQ
})));
const FinalCTA = lazy(() => import('./components/sections/FinalCTA').then(mod => ({
  default: mod.FinalCTA
})));
const Pricing = lazy(() => import('./components/sections/Pricing').then(mod => ({
  default: mod.Pricing
})));
const Guarantee = lazy(() => import('./components/sections/Guarantee').then(mod => ({
  default: mod.Guarantee
})));
const Footer = lazy(() => import('./components/sections/Footer').then(mod => ({
  default: mod.Footer
})));
export function App() {
  return <LazyMotion features={domAnimation} data-id="element-0" data-mp="3udkn7x6lywax">
      <div className="w-full min-h-full bg-bg-primary font-body text-ink" data-id="element-1" data-mp="3ucj8niqdvrog">
        <TopBar data-id="element-2" data-mp="d3cwhu6lt0hm" />
        <main data-id="element-3" data-mp="d3wc348s7csh">
          <Hero data-id="element-4" data-mp="d2bj3j2481wq" />
          <ProblemAgitation data-id="element-5" data-mp="85ui3o9tht28" />
          <Suspense fallback={null} data-id="element-6" data-mp="86meh1b8nutk">
            <TrustStats data-id="element-7" data-mp="83i3nl39q0tx" />
            <Transformation data-id="element-8" data-mp="3gleaym6kt9gr" />
            <Method data-id="element-9" data-mp="3gkl6xsz04y2b" />
            <ForYou data-id="element-10" data-mp="3glwc9x83idvj" />
            <WhatYouGet data-id="element-11" data-mp="3gja7g5clach0" />
            <BonusesDetail data-id="element-12" data-mp="3bmjqlfsyncuj" />
            <InstantAccess data-id="element-13" data-mp="3bncqbwti5236" />
            <Testimonials data-id="element-14" data-mp="3bo4n3ayu55v1" />
            <FAQ data-id="element-15" data-mp="3qb7inc3ll4fq" />
            <FinalCTA data-id="element-16" data-mp="3qbpnuy88mszs" />
            <Pricing data-id="element-17" data-mp="3qc950cq2ddcr" />
            <Guarantee data-id="element-18" data-mp="3qcimfbx1mc6u" />
          </Suspense>
        </main>
        <Suspense fallback={null} data-id="element-19" data-mp="3lk7mwa67sset">
          <Footer data-id="element-20" data-mp="3liwm8j82g0rx" />
        </Suspense>
        <StickyCTA data-id="element-21" data-mp="2xuwtjdr720ap" />
      </div>
    </LazyMotion>;
}